
import { motion } from 'framer-motion';

const FeaturesSection = () => {
  const features = [
    {
      icon: 'ri-flower-line',
      title: '春の大石桜',
      description: '境内を彩る見事なしだれ桜「大石桜」。春には多くの参拝者が訪れ、桜の下で静かな時を過ごします。',
      image: 'https://public.readdy.ai/ai/img_res/1a1393bc1d1edb033d4740cd94194254.jpg'
    },
    {
      icon: 'ri-snowflake-line',
      title: '冬の雪景色',
      description: '雪化粧された境内は、静寂と厳かさに包まれます。白銀の世界に佇む社殿は、まさに神聖な空間です。',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20shrine%20covered%20in%20fresh%20snow%20during%20winter%20night%20with%20traditional%20architecture%20illuminated%20by%20soft%20lantern%20light%20snowflakes%20gently%20falling%20creating%20peaceful%20and%20sacred%20atmosphere%20pristine%20white%20snow%20on%20roofs%20and%20grounds%20serene%20winter%20scene&width=500&height=600&seq=snow001&orientation=portrait'
    },
    {
      icon: 'ri-team-line',
      title: '義士祭',
      description: '毎年12月14日に開催される義士祭。義士装束に身を包んだ行列が、討ち入りの歴史を今に伝えます。',
      image: 'https://readdy.ai/api/search-image?query=Traditional%20Japanese%20festival%20procession%20with%20people%20dressed%20in%20samurai%20warrior%20costumes%20marching%20towards%20shrine%20during%20winter%20celebration%20historical%20reenactment%20of%20forty%20seven%20ronin%20colorful%20traditional%20attire%20festive%20atmosphere%20cultural%20heritage%20event&width=500&height=600&seq=gishi001&orientation=portrait'
    }
  ];

  return (
    <section className="bg-[#1A1A1A] py-24 px-8">
      <div className="max-w-7xl mx-auto">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <p className="text-[#D4AF37] text-sm tracking-widest mb-4">四季の見どころ</p>
          <h2 className="text-white font-bold text-5xl tracking-wide">大石神社の魅力</h2>
        </motion.div>

        <div className="grid grid-cols-3 gap-10">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="group cursor-pointer"
            >
              <div className="bg-white/5 border border-[#D4AF37]/30 rounded-lg overflow-hidden hover:border-[#D4AF37] transition-all hover:shadow-[0_0_30px_rgba(212,175,55,0.3)]">
                <div className="h-64 overflow-hidden">
                  <img 
                    src={feature.image} 
                    alt={feature.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-8">
                  <div className="w-12 h-12 flex items-center justify-center mb-4">
                    <i className={`${feature.icon} text-[#D4AF37] text-3xl`}></i>
                  </div>
                  <h3 className="text-white font-bold text-xl mb-4 tracking-wide">{feature.title}</h3>
                  <p className="text-gray-400 leading-relaxed text-sm">{feature.description}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
